export default __webpack_public_path__ + "static/media/image_2.cf202ceb.png";